import { PointExpirationScheduleFragment } from '@occc/graphql';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { DateTimeFormat, formatDateTime, parseDate } from '@occc-app/lib/date';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { TableField } from '@occc/ui-design-system';

import { pointExpirationScheduleTableMessages } from './point-expiration-schedule-table.messages';

export const formatTableDate = (date: string | null | undefined) => {
  if (!date) return '-';
  return formatDateTime(parseDate(date), DateTimeFormat.DateWithYear);
};

export const makeFields = (pointExpiration: PointExpirationScheduleFragment): TableField[] => {
  const { date, points } = pointExpiration;

  return [
    {
      label: pointExpirationScheduleTableMessages.expirationDate,
      value: formatTableDate(date),
    },
    {
      label: pointExpirationScheduleTableMessages.points,
      value: points,
      align: 'right',
    },
  ];
};
